import axios from 'axios';
import { api } from '../api';
import { sortCountries, sortDialcodes } from '../../helpers/countries.helpers';
import AppConfig from '../../providers/AppConfig';
import { hydrate } from '../slices/resources.slice';
import { hydrateResult } from '../slices/registry.slice';

const resourcesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getResources: build.query({
      queryFn: async (arg) => {
        const { metadataUrl, fetchLanguages = false } = typeof arg === 'string' ? { metadataUrl: arg } : arg;
        try {
          const requests = [axios.get(metadataUrl), axios.get('/countries/')];
          if (fetchLanguages) {
            requests.push(axios.get('/translations/languages/'));
          }
          const [metadata, countries, languages] = await Promise.all(requests);
          return {
            data: {
              ...metadata.data.data,
              countries: sortCountries(countries.data.data, AppConfig.mainCountriesIsoCodes),
              dialcodes: sortDialcodes(countries.data.data, AppConfig.mainCountriesIsoCodes),
              ...(languages && {
                languages: languages.data.data.map((item) => ({ id: item.code, name: item.name })),
              }),
            },
          };
        } catch (error) {
          return { error: { status: error.response?.status, data: error.response?.data, originalError: error } };
        }
      },
      providesTags: ['Resources'],
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          dispatch(hydrate(data));
        } catch {
          // Error handled by RTK Query
        }
      },
    }),

    getRegistryResult: build.query({
      query: ({ first_name, last_name, case_id }) => {
        const firstName = first_name ? `?first_name=${first_name}` : '';
        const lastName = last_name ? `&last_name=${last_name}` : '';
        const caseId = case_id ? `?case_id=${case_id}` : '';
        return { url: `/client-advisors/registry/${firstName}${lastName}${caseId}` };
      },
      transformResponse: (response) => response.data,
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          dispatch(hydrateResult(data));
        } catch {
          // Error handled by RTK Query
        }
      },
    }),

    search: build.query({
      query: (params) => ({ url: '/client-advisors', params }),
      transformResponse: (response) => response.data,
    }),

    checkPaymentStatus: build.query({
      query: (caseId) => ({ url: `/client-advisors/${caseId}/payment-status` }),
      transformResponse: (response) => response.data,
    }),
  }),
});

export const {
  useGetResourcesQuery,
  useLazyGetResourcesQuery,
  useGetRegistryResultQuery,
  useLazyGetRegistryResultQuery,
  useLazySearchQuery,
  useCheckPaymentStatusQuery,
} = resourcesApi;
